<template>
  <v-container fluid class="pa-0">

  <v-dialog v-model="showSuccessDialog" max-width="400" persistent>
      <v-card class="pa-6 text-center" style="border-radius: 16px;">
              <v-card-title>
                <v-row>
                <v-spacer></v-spacer>
                  <img @click="showSuccessDialog = false" src="@/assets/images/return-process/close_icon.png" width="20px" height="20px" /> 
              </v-row>
              </v-card-title>

        <span class="mb-5"><img src="@/assets/images/return-process/success_image.png" width="80px" height="80px" /> </span>

        <div class="text-h6 font-weight-bold mb-2">Return Request Submitted!</div>
        <div class="text-subtitle-2 text-grey-darken-1 mb-1">{{ formattedDate }}</div>
        <div class="text-body-2 font-weight-medium mb-6">Return ID: {{ returnId }}</div>

        <v-btn
          block
          color="#003C9E"
          class="text-white"
          @click="showSuccessDialog = false"
          style="border-radius: 12px;"
        >
          Okay
        </v-btn>
      </v-card>
    </v-dialog>
    <!-- Top Header Bar -->
    <div class="d-flex justify-space-between align-center px-6 py-4 text-white" style="background-color:#00114B !important;color:#ffffff;">
      <div>
        <div><img src="@/assets/images/return-process/logo_name.png"/> </div>
      </div>
      <div class="d-flex align-center gap-2">
          <v-icon>mdi-help-circle-outline</v-icon>
        <v-avatar size="32">
          <img src="@/assets/images/return-process/profile.png" width="32px" height="32px" alt="Avatar" />
        </v-avatar>
      </div>
    </div>

    <!-- Main Content -->
    <v-row class="pa-6 justify-center background-margin">
    <v-col cols="12">
      <v-row>
        <!-- Left side: Product Image -->
        <v-col cols="12" md="6" style="border-right: 2px solid #E2E3ED;" class="pr-4" :style="{'height': row_height}">

        <div class="mb-2 brand-name">
                Nike Legend Men Dri – FIR –
                <span class="font-weight-bold brand-price">2,000 INR</span>
            </div>
            <img
                src="@/assets/images/return-process/product_image.png"
                alt="Product Image"
                class="rounded"
                style="width: 100%; height: 78%; object-fit: cover; border-radius: 12px;"
            /> 
        </v-col>

       <v-col cols="12" md="6" class="pl-4" :style="{'height': row_height}">
          <div class="pa-4" style="width: 100%; height: 78%; object-fit: cover; background-color: #fff; border: 1px solid #ccc; border-radius: 12px;">
            <div class="text-subtitle-1 font-weight-medium mb-4 text-left">Choose a reason</div>
            <v-list class="pa-0 overflow-auto" style="height: 90%;">
                <v-list-item
                v-for="(reason, index) in returnReasons"
                :key="index"
                @click="selectedReason = reason"  
                :class="[
                    'pa-5',
                    'rounded',
                    'mb-6',
                    'border',
                    'cursor-pointer',
                    selectedReason === reason ? 'border-primary bg-blue-lighten-5' : 'border-grey-lighten-2'
                ]"
                >
                <v-list-item-title>{{ reason }}</v-list-item-title>

                <template #append>
                    <v-icon color="primary">mdi-chevron-right</v-icon>
                </template>
                </v-list-item>
            </v-list>

            <v-btn
                class="mt-10 text-none"
                block
                 style="background-color:#003C9E !important;color:#ffffff;border-radius: 12px;height:48px;"
                :disabled="!selectedReason"                
                @click="submitReturn"
            >
                Proceed Return
            </v-btn>
          </div>
        </v-col>
      </v-row>
    </v-col>
  </v-row>
  </v-container>
</template>

<script setup>
import { ref, onMounted, onBeforeUnmount } from 'vue'

const showSuccessDialog = ref(false)
const returnId = ref('')
const formattedDate = ref('')
const selectedReason = ref(null)
const row_height = ref(null)

onMounted(() => {
  calculateTableHeight()
  window.addEventListener('resize', calculateTableHeight)
})

onBeforeUnmount(() => {
  window.removeEventListener('resize', calculateTableHeight)
})

function calculateTableHeight() {
  row_height.value = (window.innerHeight - 268) + 'px'
} 

const returnReasons = [
  "It's Too Big",
  "It's Too Small",
  "It's Arrived With Delay",
  "Other Reason",
  "It Doesn't Correspond With The Website Image"
]

// Generate Return ID like SR9081773
const generateReturnId = () => {
  return 'SR' + Math.floor(10000000 + Math.random() * 90000000)
}

// Format current date/time like 23.04.2024 / 11:35 AM
const formatDate = (date) => {
  const options = {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
    hour12: true
  }
  return new Intl.DateTimeFormat('en-GB', options).format(date)
}

// Show popup on submit
const submitReturn = () => {
  if (!selectedReason.value) return
  returnId.value = generateReturnId()
  formattedDate.value = formatDate(new Date())
  showSuccessDialog.value = true
}
</script>

<style scoped>
.cursor-pointer {
  cursor: pointer;
}
.gap-2 {
  gap: 0.5rem;
}
.background-margin{
    margin: 70px 30px;
    background-color: #EDEDF8;
    /* height: 70vh; */
}
.brand-name{
    position: relative;
    left: -27%;
    padding: 15px;
    font-size: 20px;
    font-weight: 600;
}
.brand-price{
    color: #003C9E;
    font-size: 24px;
}
@media (max-width: 1400px) {
  .brand-name {
    margin-left: 20%;
  }
}
</style>
